import React, { FunctionComponent, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import actions from '@state/actions';

export const TemplatesContext = React.createContext(undefined as any);

export interface TemplatesProviderProps {
    hasDesigns: boolean;
    isLookingForDesigns:boolean;
    location: string;
}

export const TemplatesProvider: FunctionComponent<any> = (props: React.PropsWithChildren<TemplatesProviderProps>) => {
    const [hasDesigns, setHasDesigns] = useState(false);
    const [isLookingForDesigns, setIsLookingForDesigns] = useState(false);
    const [location, setLocation] = useState(props.location);
    const [searching, setSearching]= useState(false);
    const [searchQuery, setSearchQuery]= useState('');
    const [showCounter, setShowCounter]= useState(true);
    const [value, setSearchValue]= useState('');
    const [deleteId, setDeleteId]= useState('');
    const [showList, setShowList]= useState(props.location==='studio'?false:true);
    const [spinner, setSpinner]=useState(true);
    const [templatesFormat, setTemplatesFormat]=useState<any>([]);
    const [forceSearch, setForceSearch]= useState(false);
    const [sortByMenu, setSortBy]=useState([] as any);
    const [sortByText, setSortByText]=useState('');

    const [filtering, setFiltering]= useState(false);
    const [filterQuery, setFilterQuery]= useState('');

    const [move, setMove]= useState(false);

    const [counterQuery, setCounterQuery]= useState('');    


    const dispatch = useDispatch();

    useEffect(() => {
        if(templatesFormat.lenght>0)setTemplatesFormat([] as any);

        if(location==="templates")
        {   setSortBy([
                { title: "Unpublished", text:"Unpublished first", query:"c.templateStatus DESC"},
                { title: "Published", text:"Published first", query:`PUBLISHED`},
                { title: "Disabled", text:"Disabled first", query:"c.templateStatus ASC"},
                { title: "Name: ", extra:'(A-Z)', text:"A-Z", query:"c.formatName ASC"},
                { title: "Name: ", extra:'(Z-A)', text:"Z-A", query:"c.formatName DESC"},
                { title: "# of Sizes: ", extra:'(Small to Large)', text:"Smallest to Largest", query:"c.tags.formatCounter ASC"},
                { title: "# of Sizes: ", extra:'(Large to Small)', text:"Largest to Smallest", query:"c.tags.formatCounter DESC"},
                { title: "Last Edited: ", extra:'(New to Old)', text:"Newest to Oldest", query:"c.updateDate DESC"},
                { title: "Last Edited: ", extra:'(Old to New)', text:"Oldest to Newest", query:"c.updateDate ASC"},
                { title: "Described: ", extra:'(Described first)', text:"Described first.", query:"c.described DESC"}
            ]);
        }else{
            setSortBy([
                { title: "Name: ", extra:'(A-Z)', text:"A-Z", query:"c.formatName ASC"},
                { title: "Name: ", extra:'(Z-A)', text:"Z-A", query:"c.formatName DESC"},
                { title: "# of Sizes: ", extra:'(Small to Large)', text:"Smallest to Largest", query:"c.tags.formatCounter ASC"},
                { title: "# of Sizes: ", extra:'(Large to Small)', text:"Largest to Smallest", query:"c.tags.formatCounter DESC"},
                { title: "Last Edited: ", extra:'(New to Old)', text:"Newest to Oldest", query:"c.updateDate DESC"},
                { title: "Last Edited: ", extra:'(Old to New)', text:"Oldest to Newest", query:"c.updateDate ASC"}
            ]);
        }

    }, [location])

    useEffect(() => {
        if(location=='studio' && !hasDesigns && filtering && !move)setMove(true);
    }, [filtering])

    useEffect(() => {
        setHasDesigns(props.hasDesigns);
    }, [props.hasDesigns])

    useEffect(() => {
        setIsLookingForDesigns(props.isLookingForDesigns);
    }, [props.isLookingForDesigns])

    const showListemplates=(val:boolean)=>{
        if(location==='studio')setShowList(val);
    }

    const handleFiltering=(val:boolean)=>{
        if(location==="studio"){
            if(move && !filtering)setMove(false);
            
            if(val!=filtering){
                if(value==='')setShowList(val);
                else setShowList(true);
            }
        }
        setFiltering(val);
    }

    const fetchCounter = (userdata?:string) => {
        if(counterQuery!==''){
            dispatch(actions.templates.setCounter({} as any));

            return new Promise((resolve, reject) => {
                dispatch(actions.templates.fetchCounter(encodeURI('?filter='+counterQuery+'&userdata='+userdata)+"&all=true",(result, error) => {
                    if (error) reject(error)
                    else resolve(result);
                }))
            });
        }
    }

    const getQuerySearchFilters = (filters:string) => {
        const state=location==='studio'?`='PUBLISHED'`:`<>'INACTIVE'`;
        let query='';

        if(filtering && searching){
            query=`(c.templateStatus${state} and c.formatName LIKE "%${value.toLowerCase()}%" and ${filters}) or (udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus) and c.templateStatus${state} ${filters!=="" ? `and${filters}`:``})`;
        }
        else if (filtering && filters!==''){
            query=`(c.templateStatus${state} and ${filters})`;
        }
        else if (searching){
            query=`(c.templateStatus${state} and c.formatName LIKE "%${value.toLowerCase()}%") or (udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus) and c.templateStatus${state})`;
        }
        setCounterQuery(query);
        return query;
    }

    return (
        <TemplatesContext.Provider value={{
            hasDesigns,
            isLookingForDesigns,
            searching,
            setSearching: (val:boolean,)=>setSearching(val),
            forceSearch,
            setForceSearch: (val:boolean)=>setForceSearch(val),
            searchQuery,
            setSearchQuery: (val:string)=>setSearchQuery(val),
            showCounter,
            setShowCounter: (val:boolean)=>setShowCounter(val),
            value, 
            setSearchValue: (val:string)=>setSearchValue(val),
            deleteId,
            setDeleteId: (val:string)=>setDeleteId(val),
            showList,
            setShowList: (val:boolean)=>showListemplates(val),
            spinner, 
            setSpinner: (val:boolean)=>showListemplates(val),
            location,
            templatesFormat, 
            setItemsfl: (val:any)=>setTemplatesFormat(val),
            sortByMenu,
            sortByText, 
            setSortByText:(val:any)=>setSortByText(val),
            filtering, 
            setFiltering: (val:boolean)=>handleFiltering(val),
            fetchCounter,
            setCounterQuery: (val:string)=>setCounterQuery(val),
            filterQuery, 
            setFilterQuery: (val:string)=>setFilterQuery(val),
            getQuerySearchFilters: (val:string)=>getQuerySearchFilters(val),
            move
        }}>
            {props.children}
        </TemplatesContext.Provider>
    )
}